export const animateHeightStyle = {
  width: "100%",
};
